import { lazy, Suspense } from "react";
import { Navigate, Routes, Route } from "react-router-dom";

import ChoiraLoader from "./components/loader/ChoiraLoader";
import dynamicNav from "./utils/dynamicNav.js";

const Signin = lazy(() => import("./pages/admin/auth/Signin.jsx"));
const Signup = lazy(() => import("./pages/admin/auth/Signup.jsx"));
const Project = lazy(() => import("./pages/home/Project.jsx"));
const PartnerLogin = lazy(() => import("./pages/partner/auth/PartnerLogin.jsx"));
const PageNotFound = lazy(() => import("./pages/pageNotFound/PageNotFound.jsx"));
const StudioWarning = lazy(() => import("./pages/StudioNotConfigured/StudioNotConfigured.jsx"));
const AdminDashboardLayout = lazy(() => import("./pages/admin/layout/AdminDashboardLayout.jsx"));
const Studios = lazy(() => import("./pages/admin/studios/Studios.jsx"));
const AllStudioPageDetailsPage = lazy(() => import("./pages/admin/studios/AllStudioPageDetailsPage.jsx"));
const AddNewStudio = lazy(() => import("./components/adminStudio/AddNewStudio.jsx"));
const AddNewProduction = lazy(() => import("./components/adminStudio/appsAndMore/AddNewProduction.jsx"));
const AddNewCategories = lazy(() => import("./components/categories/AddNewCategories.jsx"));
const ShowBookingsDetail = lazy(() => import("./components/adminStudio/booking/ShowBookingDetails.jsx"));
const SlotBooking = lazy(() => import("./components/adminStudio/SlotBooking.jsx"));
const AddNewStudioPartners = lazy(() => import("./components/teams/AddNewStudioPartners.jsx"));
const AddNewArm = lazy(() => import("./components/teams/AddNewArm.jsx"));
const AddNewEntity = lazy(() => import("./components/entity/AddNewEntity.jsx"));

const Routing = () => {
  return (
    <Suspense fallback={<ChoiraLoader />}>
      <Routes>
        <Route exact path="/" element={<Navigate to="/signin" />} />
        <Route exact path='/signin' element={<Signin />} />
        <Route exact path='/signup' element={<Signup />} />
        <Route exact path='/project' element={<Project />} />
        <Route exact path='/partner' element={<PartnerLogin />} />
        <Route exact path='/studio-not-configure' element={<StudioWarning />} />

        <Route exact path='/studios' element={<Studios />} />
        <Route exact path='/allStudioPageDetailsPage' element={<AllStudioPageDetailsPage />} />
        <Route path={`/${dynamicNav}/:navOption/:page`} element={<AdminDashboardLayout />} />
        <Route path={`/${dynamicNav}/:navOption`} element={<AdminDashboardLayout />} />
        <Route path={`/${dynamicNav}`} element={<AdminDashboardLayout />} />
        <Route path='/partner-dashboard/Overview' element={<AdminDashboardLayout />} />
        <Route path='/partner-dashboard/Overview2' element={<AdminDashboardLayout />} />

        <Route exact path='/studio/edit' element={<AddNewStudio />} />
        <Route exact path='/studio/add' element={<AddNewStudio />} />
        <Route exact path='entity/add' element={<AddNewEntity />} />
        <Route exact path='entity/edit' element={<AddNewEntity />} />
        <Route exact path={`/${dynamicNav}/Categories/add`} element={<AddNewCategories />} />
        <Route exact path={`/${dynamicNav}/Categories/edit`} element={<AddNewCategories />} />
        <Route exact path='/service/musicProduction/edit' element={<AddNewProduction />} />
        <Route exact path='/service/musicProduction/add' element={<AddNewProduction />} />
        <Route exact path='/service/showBookingDetails' element={<ShowBookingsDetail />} />
        <Route exact path={`/${dynamicNav}/Bookings/AddSlotBooking`} element={<SlotBooking />} />
        <Route exact path={`/${dynamicNav}/Teams/AddStudioPatner`} element={<AddNewStudioPartners />} />
        <Route exact path={`/${dynamicNav}/Teams/AddNewArm`} element={<AddNewArm />} />

        <Route exact path='*' element={<PageNotFound />} />
      </Routes>
    </Suspense>
  );
};

export default Routing;
